import { render, staticRenderFns } from "./FAQAllActivities.vue?vue&type=template&id=26000228"
import script from "./FAQAllActivities.vue?vue&type=script&lang=ts"
export * from "./FAQAllActivities.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports